import React from 'react';
import Dither from './Dither';

const DitherBackground = () => {
  return (
    <div style={{ 
      width: '100%', 
      height: '100vh', 
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: -1,
      pointerEvents: 'none'
    }}>
      <Dither
        waveColor={[0.5, 0.5, 0.5]}
        disableAnimation={false}
        enableMouseInteraction={false}
        mouseRadius={0.3}
        colorNum={6}
        waveAmplitude={0.18}
        waveFrequency={3}
        waveSpeed={0.07}
      />
    </div>
  );
};

export default DitherBackground;

